<template>
  <Content title="">
    <template v-slot:title_row>
      <EditRadio/>
    </template>
    <template
      v-slot:search
    >
      <a-form
        :form="form"
        layout="inline"
        @submit.prevent.stop="handleSearch"
      >
        <a-row :gutter="32">
          <a-col :span="5">
            <a-form-item label="分组名称">
              <a-input
                v-decorator="['storeGroupName']"
                placeholder="请输入"
                autocomplete="off"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <a-button
                type="primary"
                html-type="submit"
              >查询</a-button>
              <a-button
                html-type="reset"
                @click.prevent.stop="handleSearchReset"
              >重置</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </template>
    <template
      v-slot:content
    >
      <a-button
        style="margin-bottom: 16px;"
        type="primary"
        @click="clickAddButton"
      >
        新增
      </a-button>
      <a-modal
        v-model="modalAddShow"
        :title="`${modalTableRowId ? '编辑' : '新增'}门店分组`"
        @ok="handleRowAdd"
      >
        <div
          class="d-flex row align-center"
        >
          <!-- <span class="store__group__label">分组名称：</span> -->
          <a-form >
            <a-form-item
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
              :validate-status="storeGroupName.length > 20 ? 'error' : 'success'"
              label="分组名称"
              label-align="left"
              :help="storeGroupName.length > 20 ? helpContent : ''"
            >
              <a-input
                style="width: 250px"
                v-model="storeGroupNameInput"
                @change="handleModalInputName"
                placeholder="请输入分组名称"
              />
            </a-form-item>
          </a-form>
        </div>
        <div
          class="d-flex row align-center"
        >
          <span class="store__group__label">门店列表：</span>
          <a-button
            type="default"
            @click="modalTableShow = true"
          >选择门店</a-button>
          <span style="margin-left: 10px;">已选择{{ storeIdList.length }}个门店（全部门店{{ storeAll.length }}个）</span>
        </div>
      </a-modal>
      <EditTable
        :show="modalTableShow"
        @editShowchange="modalTableShow = false"
      />
      <a-table
        :columns="columns"
        :data-source="storeGroup.list"
        :row-key="record => record.id"
        :pagination="pagination"
      >
        <template #createTimeRender="value">
          <template v-if="value">{{ value | moment($consts.DATETIME_FORMAT) }}</template>
        </template>
        <template #productNameRender="value">
          <template v-if="value">{{ value.join('、') }}</template>
        </template>
        <template #roleNameRender="value">
          <template v-if="value">{{ value.join('、') }}</template>
        </template>
        <template
          #oprRender="text, record"
          class="opr-list"
        >
          <a
            class="opr"
            @click="handleClickEdit(record)"
          >编辑</a>
          <a-popconfirm
            title="你确定要删除吗"
            @confirm="handleDelete(record.id)"
          >
            <a class="opr">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </template>
  </Content>
</template>

<script>
import { mapState } from 'vuex';
import Content from '@/components/Content';
import EditRadio from './edit-radio';
import EditTable from './edit-table';

const columns = [
  {
    title: '分组名称',
    dataIndex: 'storeGroupName',
    width: '40%',
  },
  {
    title: '门店数量',
    dataIndex: 'storeCount',
  },
  {
    title: '操作',
    key: 'opr',
    scopedSlots: { customRender: 'oprRender' },
  },
];

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};
export default {
  components: {
    Content, EditRadio, EditTable,
  },
  data() {
    return {
      formItemLayout,
      columns,
      currPage: 1,
      currFieldsValue: {},
      form: this.$form.createForm(this, { name: 'group_search' }),
      // modal相关
      modalAddShow: false,
      modalTableShow: false,
      modalTableRowId: null,
      helpContent: '请输入20个字符内的分组名称',
    };
  },
  computed: {
    ...mapState('storeManage', ['storeGroup', 'storeGroupName', 'storeIdList', 'storeAll']),
    pagination() {
      return {
        current: this.currPage,
        defaultPageSize: this.$consts.PAGE_SIZE,
        total: this.storeGroup.total,
        onChange: this.handlePagination,
      };
    },
    storeGroupNameInput() {
      return this.storeGroupName;
    },
  },
  methods: {
    async loadData(pageNum = 1) {
      this.currPage = pageNum;
      this.$store.dispatch('storeManage/fetchGroup', {
        pageNum,
        pageSize: this.$consts.PAGE_SIZE,
        ...this.currFieldsValue,
      });
    },
    handleDelete(id) {
      this.$store.dispatch('storeManage/fetchGroupDelete', { id })
        .then(() => {
          this.$message.success('删除数据成功');
          this.loadData();
        });
    },
    handleRowAdd() {
      const { storeGroupName, storeIdList, modalTableRowId } = this;
      if (!storeGroupName) {
        this.$message.warn('请输入门店分组名称');
        return;
      }
      if (storeGroupName.length > 20) {
        return;
      }
      if (!storeIdList.length) {
        this.$message.warn('请选择门店');
        return;
      }
      if (modalTableRowId) {
        this.$store.dispatch('storeManage/fetchGroupEdit', { id: modalTableRowId, storeGroupName, storeIdList })
          .then(() => {
            this.$message.success('更新数据成功');
            this.modalAddShow = false;
            this.loadData();
          });
      } else {
        this.$store.dispatch('storeManage/fetchGroupAdd', { storeGroupName, storeIdList })
          .then(() => {
            this.$message.success('新增数据成功');
            this.modalAddShow = false;
            this.loadData();
          });
      }
    },
    // 点击编辑按钮 - 赋值
    handleClickEdit(account) {
      const { storeGroupName, storeIdList, id } = account;
      this.$store.commit('storeManage/updateModalGroupName', storeGroupName);
      this.$store.commit('storeManage/updateModalStoreIdList', storeIdList || []);
      this.modalAddShow = true;
      this.modalTableRowId = id;
    },
    handleModalInputName(e) {
      this.$store.commit('storeManage/updateModalGroupName', e.target.value);
    },
    handlePagination(pageNum) {
      this.loadData(pageNum);
    },
    handleSearch() {
      this.currFieldsValue = this.form.getFieldsValue();
      this.loadData();
    },
    handleSearchReset() {
      this.form.setFieldsValue({ storeGroupName: '' });
      this.handleSearch();
    },
    clickAddButton() {
      this.$store.commit('storeManage/updateModalGroupName');
      this.$store.commit('storeManage/updateModalStoreIdList');
      this.modalAddShow = true;
      this.modalTableRowId = null;
    },
  },
  created() {
    this.loadData();
  },
};
</script>
<style>
  .store__group__label {
    width: 95px;
  }
</style>
